import { Injectable, ChangeDetectorRef } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable, of } from 'rxjs';
import { catchError, map, tap, timeout } from 'rxjs/operators';

import { Aluno, Produto,Cart, CartItem  } from './tamas-models';

import { MessageService } from './message.service';
import { Subject } from 'rxjs/index';

import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import {AlertaSimplesDialog} from './alerta-simples';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};
const httpOptions2 = {
  headers: new HttpHeaders({ 'Content-Type': '' })
};

declare function infoDeslogado() : any;

@Injectable({ providedIn: 'root' })
export class TamasAlunoService {
    private urlBase = "https://app.tamasapp.com.br";
    // private urlBase = "http://localhost:5280";
    //private urlBaseLocal = "http://localhost:5280";
    public urlRepositorioS3 = "https://tamasappcdn.s3.sa-east-1.amazonaws.com";
    //public urlRepositorioS3 = "https://tamasappfiles.s3.sa-east-1.amazonaws.com";

    private alunosUrl = this.urlBase + '/publico/alunos';  // URL to web api
    private loginUrl = this.urlBase + '/publico/userLoginPadrao';
    private checkUserEmailUrl = this.urlBase + '/publico/userLoginCheckEmail';
    private welcomePreUrl = this.urlBase + '/publico/welcomePre';
    
    private resendCodeUrl = this.urlBase + '/publico/resendcodigo';
    private recuperarSenhaUrl = this.urlBase + '/publico/recuperarsenha';
    private alterarRecSenhaUrl = this.urlBase + '/publico/alterarsenha';
    private novousuarioUrl = this.urlBase + '/publico/novocadastro';
    private addFotoPerfilUrl = this.urlBase + '/publico/usuarioFotoPerfil';
    private addFotosUrl = this.urlBase + '/publico/usuarioFotoSecundaria';
    private deletarFotoSUrl = this.urlBase + '/publico/usuarioDeletarFotoSec';
    private notifyUrl = this.urlBase + '/publico/ajustenotificacoes?';
    private perfilPubUrl = this.urlBase + '/publico/perfiluserpublico?'
    private perfilFullUrl = this.urlBase + '/publico/perfilFull?'
    private perfilDetailUrl = this.urlBase + '/publico/infodetalhada?';
    private alterarDadoPerfilUrl = this.urlBase + '/publico/atualizarDadoPerfil';
    private checkNomeUsuarioUrl = this.urlBase + '/publico/checknomeusuario?'
    private usuarioLocalUrl = this.urlBase + '/publico/usuariolocalorigem?';
    //seguir
    private followUserUrl = this.urlBase + '/publico/addSeguidor';
    private unfollowUserUrl = this.urlBase + '/publico/removerSeguidor';

    private autorizarTorcedorUrl = this.urlBase + '/social/AprovarTorcedor';
    //avaliacao url
    private listarAvaliacoesUrl = this.urlBase + '/publico/listarAvaliacoes?';
    private alInfoAvaliacaoUrl = this.urlBase + '/publico/infoAvaliacao?';
    private compararAvaliacoesUrl = this.urlBase + '/publico/compararAvaliacoes';
    //dieta urls
    private listarDietasUrl = this.urlBase + '/publico/listarDietas?';
    private listarRefeicoesDiaUrl  = this.urlBase + '/publico/listaRefeicoesDia?';
    private listarRefeicoesHjUrl = this.urlBase + '/publico/listaRefeicoesHoje?';
    private addRefeicaoDoneUrl = this.urlBase + '/publico/salvarRefeicao';
    private modNotificacoesGUrl = this.urlBase + '/publico/alterarNotifyGeral?'
    private modNotificacoesEUrl = this.urlBase + '/publico/alterarNotifyEsp?';
    private ativarNDUrl = this.urlBase + '/publico/ativarNotificacaoDieta';

    //treinos url - ficha ficar monstrao
    private listarTreinosUrl = this.urlBase + '/publico/listarTreinos?';
    //todos os treinos - peito e costa etc
    private listarDiasTreinoUrl = this.urlBase + '/publico/listarDiasTreino?';
    //exercicios que compõe o treino
    private listarTreinoUrl = this.urlBase + '/publico/listarTreino?';
    private salvarTreinoUrl = this.urlBase + '/publico/salvarTreino?';


    //notificacoesConsultarNumNotify
    private qtyNotificacoesUrl = this.urlBase + '/sysmsg/ConsultarNumNotify?';
    private listarNotificacoesUrl = this.urlBase + '/sysmsg/listarNotificacoes?';
    private listarNotificacaoUrl = this.urlBase + '/sysmsg/listarNotificacao?';
    private notificacaoViUrl = this.urlBase + '/sysmsg/NotificacaoVisualizada';
    private aceiteProUrl = this.urlBase + '/sysmsg/AceitarPro';

    private excluirContaUrl = this.urlBase + '/publico/excluirConta';

    //favoritar
    private addFavUrl = this.urlBase + '/publico/addFavorito?';
    private removeFavUrl = this.urlBase + '/publico/removeFavorito?';

  //pesquisa url
    private pesquisarUsuarioUrl = this.urlBase + '/publico/pesquisarUsuario?';
    private pesquiasrlpUrl = this.urlBase + '/publico/pesquisarLP?';

    private infoEspecificaUrl = this.urlBase + '/publico/infoespecifica?';

    private listarBModalidadesUrl = this.urlBase + '/publico/listaBaseModalidades';
    private salvarModalidadesUrl = this.urlBase + '/publico/salvarmodalidades';
    private removeModalidadeUrl = this.urlBase + '/publico/removermodalidade?';

    private salvarConqUrl = this.urlBase + '/publico/addnovaconquista';
    private infoConqUrl = this.urlBase + '/publico/infoconquista?';
    private removeConqUrl = this.urlBase + '/publico/removerconquista?';
    private listarBaseCompeticoesUrl = this.urlBase + '/publico/listabasecompeticoes';
    private salvarTituloUrl = this.urlBase + '/publico/addnovotitulo';
    private removeTituloUrl = this.urlBase + '/publico/removertitulo?';
    private infoTituloUrl = this.urlBase + '/publico/infotitulo?';

    private listarCfgUrl = this.urlBase + '/publico/listarPreferencias?';
    private atualizarCfgUrl = this.urlBase + '/publico/atualizarPreferencias?';
    private editarTipoPerfilUrl = this.urlBase + '/publico/AlterarTipoPerfil';

    //etapas cadastro
    private validarcodigoClienteUrl = this.urlBase + '/publico/validarCadastro'
    private validarCodigoEmailUrl = this.urlBase + '/publico/validarByEmail'
    private salvarULocalUrl = this.urlBase + '/publico/salvarUserLocal';
    private salvarUFisicUrl = this.urlBase + '/publico/salvarUserFisic';
    private salvarFotoPUrl = this.urlBase + '/publico/salvarFotoPerfil';
    private salvarNickUrl = this.urlBase + '/publico/salvarNickUsuario';
    private salvarTemaUrl = this.urlBase + '/publico/salvarTema';
    

    //chat things
    private listarChatsUrl = this.urlBase + '/chat/listarChats';
    private carregarMsgChatUrl = this.urlBase + '/chat/msgChat';
    private carregarMsgOldChatUrl = this.urlBase + '/chat/loadOldMsg';
    private chatBrokerUrl = this.urlBase + '/chat/msgBroker';
    private chatAllBroker = this.urlBase + '/chat/brokerAllChat';
    private chatListBrokerUrl = this.urlBase + '/chat/brokerChats';
    private chatAddMsgUrl = this.urlBase + '/chat/addMsg';
    //private chatAddMsgUrl = 'http://localhost:5280/chat/addMsg';
    private contatosListarUrl = this.urlBase + '/chat/listarses';
    private contatopesquisarUrl = this.urlBase + '/chat/pesquisarses';

    private blockUserUrl = this.urlBase + '/chat/blockuser';
    private unblockUserUrl = this.urlBase + '/chat/unblockuser';
    //premium
    private checkCupomPremiumUrl = this.urlBase + '/publico/checkCupomPLano';
    private planosPremiumUrl = this.urlBase + '/publico/infoPremiumPlans';
    private planosPremiumPSUrl = this.urlBase + '/publico/infoPremiumPlansPS';
    private assinarPlanoPremiumUrl = this.urlBase + '/publico/assinarPremium';
    private assinarPlanoPremiumPSUrl = this.urlBase + '/publico/assinarPremiumPg';
    private statusPremiumUrl = this.urlBase + '/publico/StatusMeuPremium';

    //feed
    private socialCarregarFeedUrl = this.urlBase + '/social/CarregarFeed';
    private socialCarregarPostUrl = this.urlBase + '/social/CarregarPost';
    private socialCarregarCommentUrl = this.urlBase + '/social/CarregarComentarios';
    private socialCarregarReactUrl = this.urlBase + '/social/CarregarReacoes';
    private socialInserirCommentUrl = this.urlBase + '/social/InserirComentario';
    private socialInserirReactUrl = this.urlBase + '/social/InserirReacao';
    private socialRemoverReactUrl = this.urlBase + '/social/RemoverReacao';
    private socialInserirPostUrl = this.urlBase + '/social/InserirNovoPost';
    private socialFeedLoadSimpUrl = this.urlBase + '/social/feedsimplificado';
    private socialReportarPostUrl = this.urlBase + '/social/reportarpost';
    private carregarNetworkUrl = this.urlBase + '/social/CarregarNetwork';
    private exlcuirPostUrl = this.urlBase + '/social/RemoverPublicacao';


    //shop
    private listarUFshopUrl = this.urlBase + '/publico/shoplistaruf2';
    private listarCidadesshopUrl = this.urlBase + '/publico/shoplistarcidades?';
    private listarShopCatsUrl = this.urlBase + '/publico/shopcategorias';
    private listarShopDHUrl = this.urlBase + '/publico/shopdestaqueshome?';
    private infoProdUrl = this.urlBase + '/publico/shopproddetails?';
    private listarProdByCSUrl = this.urlBase + '/publico/shoplistabycs?'
    private listarEnderecosUrl = this.urlBase + '/ecommerce/listarmeusenderecos?'
    private novoEnderecoUrl = this.urlBase + '/ecommerce/addnovoenderecoe';
    private excluirEnderecoUrl = this.urlBase + '/ecommerce/removerendereco?';
    private listarPedidosUrl = this.urlBase + '/ecommerce/checkCPedidos?';
    private infoPedidoUrl = this.urlBase + '/ecommerce/checkCPedido?';
    private addNovoPedidoUrl = this.urlBase + '/publico/addNovopedidoMulti';
    private addNovoPedidoNewUrl = this.urlBase + '/ecommerce/addNovopedidoMulti';
    private criarSPSUrl = this.urlBase + '/publico/CriarNovaSP';
    private checkQtyUrl = this.urlBase + '/publico/verifyQtyProd';
    private saveTempCartUrl = this.urlBase + '/sysmsg/SalvarTempCart';
    private zerarTempCartUrl = this.urlBase + '/sysmsg/ExcluirTempCart';
    private lReceitastUrl = this.urlBase + '/publico/ListarReceitas';
    private iReceitaUrl = this.urlBase + '/publico/InfoReceita';
    private avaliarPedidoUrl = this.urlBase + '/publico/AvaliarPedido';

    //dashboard
    //dashPacientes
    private listarPacientesUrl = this.urlBase + '/prodash/pesquisarPacientes?';
    private listarUltimosPacientesUrl = this.urlBase + '/prodash/ultimospacientes?';
    private listarUltimasPrecricoesUrl = this.urlBase + '/prodash/ultimasprescricoes?';
    private listarUltimasAvaliacoesUrl = this.urlBase + '/prodash/ultimasavaliacoes?';
    private listarUsuariosP = this.urlBase + '/prodash/pesquisarUsuarios?';
    private novoPreCadastroUrl = this.urlBase + '/prodash/realPreCadastro';
    private novaRelacaoPAUrl = this.urlBase + '/prodash/criarRelacaoPA';


    private listarInfoPacienteUrl = this.urlBase + '/prodash/infoPaciente?';
    private buscarAderenciaAliUrl = this.urlBase + '/prodash/aderenciaPlanoAli?';
    private buscarAderenciaTreUrl = this.urlBase + '/prodash/aderenciaPlanoTre?';
    private listarAvalUrl = this.urlBase + '/prodash/listarAvaliacoes?';
    private infoAvaliacaoUrl = this.urlBase + '/prodash/infoAvaliacao?'
    private compararAvUrl = this.urlBase + '/prodash/compararAvaliacoesNew';
    private novaAvUrl = this.urlBase + '/prodash/novaAvaliacao';
    private salvarAvUrl = this.urlBase + '/prodash/salvaravaliacao';
    private salvarTCUrl = this.urlBase + '/prodash/calcCooper';
    private salvarRMUrl = this.urlBase + '/prodash/calcRM';
    private salvarDobrasUrl = this.urlBase + '/prodash/calcDobras';
    private salvarGETUrl = this.urlBase + '/prodash/calcGastoET';
    private excluirAvUrl = this.urlBase + '/prodash/excluirAvaliacao';

    private novoPlanoAliUrl = this.urlBase + '/prodash/novoPlanoAli';
    private novoPlanoExcUrl = this.urlBase + '/prodash/novoPlanoExc';
    private infoPlanoAliUrl = this.urlBase + '/prodash/infoPlanoAli?';
    private infoPlanoExcUrl = this.urlBase + '/prodash/infoPlanoExc?';
    
    private envPlanoExcUrl = this.urlBase + '/prodash/enviarPlanoExc';
    private envPlanoAliUrl = this.urlBase + '/prodash/enviarPlanoAli';


    private addNovaRefUrl = this.urlBase + '/prodash/inserirRefeicao';
    private atualizarRefUrl = this.urlBase + '/prodash/editarRefeicao';
    private excluirRefUrl = this.urlBase + '/prodash/deletarRefeicao';


    private salvarModeloAliUrl = this.urlBase + '/prodash/salvarModeloAli';
    private importarModeloAliUrl = this.urlBase + '/prodash/importarModeloAli';
    private listarMrMsUrl = this.urlBase + '/prodash/listarMacMes?'


    private listarFichasTUrl = this.urlBase + '/prodash/listarFichasTreino?';
    private listarExerciciosTUrl = this.urlBase + '/prodash/listarExerciciosT?';

    private novaFichaExcUrl = this.urlBase + '/prodash/addFichaTreino';
    private novoExcTUrl = this.urlBase + '/prodash/addExercicioT';
    private attExcTUrl = this.urlBase + '/prodash/editarExercicioT';

    private excluirFichaTUrl = this.urlBase + '/prodash/excluirFichaTreino';
    private excluirPlanoTUrl = this.urlBase + '/prodash/excluirPlanoExc';
    private excluirPlanoAUrl = this.urlBase + '/prodash/deletarPlanoAli';
    private excluirExercicioTUrl = this.urlBase + '/prodash/excluirExercicioT';
    private excluirMacroTUrl = this.urlBase + '/prodash/excluirMacroT';
    
    //contatos
    private envCTNegocioUrl = this.urlBase + '/publico/enviarcontatonegocios';
    private envCTSimplesUrl = this.urlBase + '/publico/enviarcontatosimples';

    private wsViaCEP = 'https://viacep.com.br/ws/';

    tempTorcedores: any[] = [];
    tempTorcendo: any = [];
    tempIdxTs: any = 0;
    tempIdxTo: any = 0;
    tempQtyTs: any = 0;
    tempQtyTo: any = 0;
    tempContatoPos: any = 0;
    tempPerfilRS: any = '';
    tempPesquisaPos: any = 0;
    tempPesquisaRef: any = '';
    
    //busca - armazenar no service
    tempPessoasL: any[] = [];
    tempPessoasG: any[] = [];
    tempTermo: any = '';
    tempPesquisaIdxL: any = 0;
    tempPesquisaIdxG: any = 0;

    pickCidade: boolean = false;
    logado: boolean = false;
    paginaAnterior: any = '';
    logadoNome: any = '';
    tempoDescansoChange: Subject<boolean> = new Subject<boolean>();
    buscandoChange: Subject<boolean> = new Subject<boolean>();
    buscaAtiva: boolean = false;
    modoFChange: Subject<boolean> = new Subject<boolean>();
    screenPriority: boolean;
    glTempoDescanso: any = 0;
    glSerieAtual: any = 0;
    glTotalSeries: any =0;
    arrSeriesRlz: any[] = [];
    arrRefeicoesDone: any[] = [];
    arrExerciciosDone: any[] = [];
    glIdExercicioAtual: any = 0;
    glIdTreinoAtual: any = 0;
    qPagina: any = '';
    shopUF: any = '';
    shopCidade: any = '';
    
    shopCarrinho: CartItem[] = [];
    shopCartFull: Cart[] = [];
    shopQtyF: any = 0;
    shopIdLoja: any = 0;
    shopLojaAtual: any = 1;
    //se trocar cidade = clearcart;
    shopCidadeAtual: any = '';
    shopUrlAnterior: any = '';
    shopEnderecoEntrega: any[] = [];
    shopValorTotal: any = 0;
    shopCheck: boolean = false;
    shopTipoFrete: any = '';
    //shopValorTotalP: any = 0;
    //cadastro e etc
    gUrlAnterior: any = '';
    gUrlPerfilPai: any = '';
    gArrUrlPrev : any[] = [];
    gBackBusca: boolean = false;

    hcNome: any = '';
    hcEmail: any = '';
    hcSenha: any = '';
    hcFoto: any = '';
    hcNomeUsuario: any = '';
    hcEtapa: any = 0;
    hcTreinoFix: any = 0;
    hcDietaFix: any = 0;
    hcIsPro: boolean = false;
    hcProAtivo: boolean = false;
    hcPremium: boolean = false;
    hcUid: any = 0;
    hcSO: any = '';
    hcWA: boolean = true;
    mModalidades: any[] = [];
    mModLoaded: boolean = false;
    
    intervalAllChat: any = '';
    intervalNotify: any = '';
    glArrProdutosHome: any[] = [];
    glArrBanners: any[] = [];
    glDHload: boolean = false;
    glArrShopCat: any[] = [];
    glArrShopSub: any[] = [];
    glCatLoad: boolean = false;
    glTimeLastLoad: any = '';
    
    glDestinoCampanha: any = '';
    meutimeout: any = 45000;
    private _darkTheme = new Subject<boolean>();
    isDarkTheme = this._darkTheme.asObservable();

    chatQtyChange: Subject<number> = new Subject<number>();
    hcChatMsg: number = 0;

    usuarioToken: any;
    notificacaoAtiva: boolean = false;
    notificationChange: Subject<boolean> = new Subject<boolean>();

    notifyQtyhange: Subject<number> = new Subject<number>();
    hcNotify: number = 0;

    acReceitaPos: number = -1;

    //social things
    socialTipo: any = '';
    visualTT: any = '';

    constructor(
        private http: HttpClient, private mda: MatDialog,
        private messageService: MessageService) { 
            this.chatQtyChange.subscribe((value) =>{
              this.hcChatMsg = value;
            })


            this.notifyQtyhange.subscribe((value) =>{
              this.hcNotify = value;
            })
        }

       
        criarIntervalChat(){
          if(this.intervalAllChat == ''){
            this.globalAllChat();
            this.intervalAllChat = setInterval(() => {
              this.globalAllChat();
            }, 90000);
          }
        }

        criarIntervalNotify(){
          if(this.intervalNotify == ''){
            this.globalNotify();
            this.intervalNotify = setInterval(() => {
              this.globalNotify();
            }, 300000);
          }
        }



        globalAllChat(){
          let customParams = {
            //lista: localStorage.getItem('turboCart'),
            email: this.hcEmail,
            senha: this.hcSenha,
          };
          this.brokerAllChat(customParams).subscribe((qRes) => {
            //this.hideCL = true;
            console.log(qRes);
            if (qRes['res'] == 'done') {
                //this._hcChat.next(qRes['qtyMsg']);
                this.chatQtyChange.next(qRes['qtyMsg']);
                console.log(this.chatQtyChange);
                console.log(this.hcChatMsg);
            }
            
          },
            (error) => {
             console.log(error);
            })
        }


        globalNotify(){
          let customParams = {
            //lista: localStorage.getItem('turboCart'),
            email: this.hcEmail,
            senha: this.hcSenha,
          };
          this.getQtyNotificacoes(customParams).subscribe((qRes) => {
            //this.hideCL = true;
            console.log(qRes);
            if (qRes['res'] == 'done') {
                //this._hcChat.next(qRes['qtyMsg']);
                this.notifyQtyhange.next(qRes['qty']);
            }
          },
            (error) => {
             console.log(error);
            })
        }


        setDarkTheme(isDarkTheme: boolean): void {
          this._darkTheme.next(isDarkTheme);
          console.log(this._darkTheme);
          console.log(this.isDarkTheme);
        }

        eventoNovoTempo(novoTDescanso: boolean){
            this.tempoDescansoChange.next(this.glTempoDescanso = novoTDescanso);    
        }
        eventoBuscar(taBuscando: boolean){
          this.buscandoChange.next(this.buscaAtiva = taBuscando);    
          
        }
        eventoFS(isFull: boolean){
          this.modoFChange.next(this.screenPriority = isFull);
        }

        exibeAlertaService(textoNotify: string) :void{
          let someDialog = this.mda.open(AlertaSimplesDialog, {
            width: '300px',
            // autoFocus: true,
            data: {tituloAlerta: 'Aviso', textoAlerta:textoNotify}
          });
          //this.cdRef.detectChanges();
        }
       

        getAlunos (): Observable<Aluno[]> {
            return this.http.get<Aluno[]>(this.alunosUrl)
              .pipe(
                tap(heroes => this.log('fetched heroes')),
                catchError(this.handleError('getCategorias', []))
              );
          }

          getLogin (dadosLogin: any):  Observable<any[]>{
            return this.http.post<any[]>(this.loginUrl, JSON.stringify(dadosLogin), httpOptions)
            .pipe(
              tap(heroes => this.log('ok')),
              catchError(this.handleError('Cli', []))
            );
          }

          welcomePreUser(dadosLogin: any):  Observable<any[]>{
            return this.http.post<any[]>(this.welcomePreUrl, JSON.stringify(dadosLogin), httpOptions)
            .pipe(
              tap(heroes => this.log('ok')),
              catchError(this.handleError('Cli', []))
            );
          }

          checkUserEmail(dadosUsuario: any) : Observable<any[]>{
            return this.http.post<any[]>(this.checkUserEmailUrl, JSON.stringify(dadosUsuario), httpOptions)
            .pipe(
              tap(heroes => this.log('ok')),
              catchError(this.handleError('Cli', []))
            );
          }

          confirmarCodigoCadastro(dadosUsuario: any) : Observable<any[]>{
            return this.http.post<any[]>(this.validarcodigoClienteUrl, JSON.stringify(dadosUsuario), httpOptions)
            .pipe(
              tap(heroes => this.log('ok')),
              catchError(this.handleError('Cli', []))
            );
          }

          confirmarCodigoByEmail(dadosUsuario: any) : Observable<any[]>{
            return this.http.post<any[]>(this.validarCodigoEmailUrl, JSON.stringify(dadosUsuario), httpOptions)
            .pipe(
              tap(heroes => this.log('ok')),
              catchError(this.handleError('Cli', []))
            );
          }

          salvarUserLocal(dadosUsuario: any) : Observable<any[]>{
            return this.http.post<any[]>(this.salvarULocalUrl, JSON.stringify(dadosUsuario), httpOptions)
            .pipe(
              tap(heroes => this.log('ok')),
              catchError(this.handleError('Cli', []))
            );
          }

          salvarUserFisic(dadosUsuario: any) : Observable<any[]>{
            return this.http.post<any[]>(this.salvarUFisicUrl, JSON.stringify(dadosUsuario), httpOptions)
            .pipe(
              tap(heroes => this.log('ok')),
              catchError(this.handleError('Cli', []))
            );
          }
          salvarUserFotoP(dadosUsuario: any) : Observable<any[]>{
            return this.http.post<any[]>(this.salvarFotoPUrl, JSON.stringify(dadosUsuario), httpOptions)
            .pipe(
              tap(heroes => this.log('ok')),
              catchError(this.handleError('Cli', []))
            );
          }
          salvarUserNick(dadosUsuario: any) : Observable<any[]>{
            return this.http.post<any[]>(this.salvarNickUrl, JSON.stringify(dadosUsuario), httpOptions)
            .pipe(
              tap(heroes => this.log('ok')),
              catchError(this.handleError('Cli', []))
            );
          }
          salvarUserTema(dadosUsuario: any) : Observable<any[]>{
            return this.http.post<any[]>(this.salvarTemaUrl, JSON.stringify(dadosUsuario), httpOptions)
            .pipe(
              tap(heroes => this.log('ok')),
              catchError(this.handleError('Cli', []))
            );
          }

          goResendCode(dadosRec: any) : Observable<any[]>{
            return this.http.post<any[]>(this.resendCodeUrl, JSON.stringify(dadosRec), httpOptions)
            .pipe(
              tap(heroes => this.log('ok')),
              catchError(this.handleError('Cli', []))
            );
          }
          goRecuperar(dadosRec: any) : Observable<any[]>{
            return this.http.post<any[]>(this.recuperarSenhaUrl, JSON.stringify(dadosRec), httpOptions)
            .pipe(
              tap(heroes => this.log('ok')),
              catchError(this.handleError('Cli', []))
            );
          }

          alterarSenha(dadosRec: any) : Observable<any[]>{
            return this.http.post<any[]>(this.alterarRecSenhaUrl, JSON.stringify(dadosRec), httpOptions)
            .pipe(
              tap(heroes => this.log('ok')),
              catchError(this.handleError('Cli', []))
            );
          }


          addNovoUsuario(novoUsuarioParameters: any) : Observable<any[]>{
            return this.http.post<any[]>(this.novousuarioUrl, JSON.stringify(novoUsuarioParameters), httpOptions)
            .pipe(
              tap(heroes => this.log('ok')),
              catchError(this.handleError('Cli', []))
            );
          }

          addFotoPerfil (dadosUser: any): Observable<any[]> {
            return this.http.post<any[]>(this.addFotoPerfilUrl, JSON.stringify(dadosUser), httpOptions)
              .pipe(
                tap(heroes => this.log('done dadosLog')),
                catchError(this.handleError('getVlr', []))
              );
          }
          addFotoSec (dadosUser: any): Observable<any[]> {
            return this.http.post<any[]>(this.addFotosUrl, JSON.stringify(dadosUser), httpOptions)
              .pipe(
                tap(heroes => this.log('done dadosLog')),
                catchError(this.handleError('getVlr', []))
              );
          }
          
          deletarFotoSec(dadosUser: any): Observable<any[]> {
            return this.http.post<any[]>(this.deletarFotoSUrl, JSON.stringify(dadosUser), httpOptions)
              .pipe(
                tap(heroes => this.log('done dadosLog')),
                catchError(this.handleError('getVlr', []))
              );
          }
          
          listarPerfilP (dadosLogin: string): Observable<any[]> {
            return this.http.get<any[]>(this.perfilPubUrl + dadosLogin)
              .pipe(
                tap(heroes => this.log('done dadosLog')),
                timeout(20000),
                catchError(this.handleError('getVlr', []))
              );
          }
          listarPerfilFull (dadosLogin: string): Observable<any[]> {
            return this.http.get<any[]>(this.perfilFullUrl + dadosLogin)
              .pipe(
                tap(heroes => this.log('done dadosLog')),
                timeout(20000),
                catchError(this.handleError('getVlr', []))
              );
          }
          editarDadoPerfil(dadosUser: any): Observable<any[]> {
            return this.http.post<any[]>(this.alterarDadoPerfilUrl, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', []))
            );
        }
          altUsuarioLocal(dadosLogin: string): Observable<any[]> {
            return this.http.get<any[]>(this.usuarioLocalUrl + dadosLogin)
              .pipe(
                tap(heroes => this.log('done dadosLog')),
                timeout(20000),
                catchError(this.handleError('getVlr', []))
              );
          }
          altUsuarioNick(dadosLogin: string): Observable<any[]> {
            return this.http.get<any[]>(this.checkNomeUsuarioUrl + dadosLogin)
              .pipe(
                tap(heroes => this.log('done dadosLog')),
                timeout(20000),
                catchError(this.handleError('getVlr', []))
              );
          }
          listarDadosPerfil (dadosLogin: string): Observable<any[]> {
            return this.http.get<any[]>(this.perfilDetailUrl + dadosLogin)
              .pipe(
                tap(heroes => this.log('done dadosLog')),
                timeout(20000),
                catchError(this.handleError('getVlr', []))
              );
          }

          listarAvaliacoes (dadosLogin: string): Observable<any[]> {
            return this.http.get<any[]>(this.listarAvaliacoesUrl + dadosLogin)
              .pipe(
                tap(heroes => this.log('done dadosLog')),
                timeout(20000),
                catchError(this.handleError('getVlr', []))
              );
          }
          infoAvaliacao(dadosLogin: string): Observable<any[]> {
            return this.http.get<any[]>(this.alInfoAvaliacaoUrl + dadosLogin)
              .pipe(
                tap(heroes => this.log('done dadosLog')),
                timeout(20000),
                catchError(this.handleError('getVlr', []))
              );
          }

          compararAvaliacoes(dadosUsuario: any) : Observable<any[]>{
            return this.http.post<any[]>(this.compararAvaliacoesUrl, JSON.stringify(dadosUsuario), httpOptions)
            .pipe(
              tap(heroes => this.log('ok')),
              catchError(this.handleError('Cli', []))
            );
          }

          listarDietas (dadosLogin: string): Observable<any[]> {
            return this.http.get<any[]>(this.listarDietasUrl + dadosLogin)
              .pipe(
                tap(heroes => this.log('done dadosLog')),
                timeout(20000),
                catchError(this.handleError('getVlr', []))
              );
          }

          listarRefeicoesD (dadosLogin: string): Observable<any[]> {
            return this.http.get<any[]>(this.listarRefeicoesDiaUrl + dadosLogin)
              .pipe(
                tap(heroes => this.log('done dadosLog')),
                timeout(20000),
                catchError(this.handleError('getVlr', []))
              );
          }

          listarRefeicoesHj (dadosLogin: string): Observable<any[]> {
            return this.http.get<any[]>(this.listarRefeicoesHjUrl + dadosLogin)
              .pipe(
                tap(heroes => this.log('done dadosLog')),
                timeout(20000),
                catchError(this.handleError('getVlr', []))
              );
          }

          checkRefeicaoDone(dadosRefeicao: any) : Observable<any[]>{
            return this.http.post<any[]>(this.addRefeicaoDoneUrl, JSON.stringify(dadosRefeicao), httpOptions)
            .pipe(
              tap(heroes => this.log('ok')),
              catchError(this.handleError('Cli', []))
            );
          }
          alterarNotificacoesE (dadosLogin: string): Observable<any[]> {
            return this.http.get<any[]>(this.modNotificacoesEUrl + dadosLogin)
              .pipe(
                tap(heroes => this.log('done dadosLog')),
                timeout(20000),
                catchError(this.handleError('getVlr', []))
              );
          }

          alterarNotificacoesG(dadosLogin: string): Observable<any[]> {
            return this.http.get<any[]>(this.modNotificacoesGUrl + dadosLogin)
              .pipe(
                tap(heroes => this.log('done dadosLog')),
                timeout(20000),
                catchError(this.handleError('getVlr', []))
              );
          }

          listarTreinos (dadosLogin: string): Observable<any[]> {
            return this.http.get<any[]>(this.listarTreinosUrl + dadosLogin)
              .pipe(
                tap(heroes => this.log('done dadosLog')),
                timeout(20000),
                catchError(this.handleError('getVlr', []))
              );
          }
          listarDiasTreino (dadosLogin: string): Observable<any[]> {
            return this.http.get<any[]>(this.listarDiasTreinoUrl + dadosLogin)
              .pipe(
                tap(heroes => this.log('done dadosLog')),
                timeout(20000),
                catchError(this.handleError('getVlr', []))
              );
          }
          listarTreino (dadosLogin: string): Observable<any[]> {
            return this.http.get<any[]>(this.listarTreinoUrl + dadosLogin)
              .pipe(
                tap(heroes => this.log('done dadosLog')),
                timeout(20000),
                catchError(this.handleError('getVlr', []))
              );
          }
          salvarTreino (dadosLogin: string): Observable<any[]> {
            return this.http.get<any[]>(this.salvarTreinoUrl + dadosLogin)
              .pipe(
                tap(heroes => this.log('done dadosLog')),
                timeout(20000),
                catchError(this.handleError('getVlr', []))
              );
          }

          getJsonBR (dadosLogin: string): Observable<any[]> {
            return this.http.get<any[]>('/assets/dados/estados.json')
              .pipe(
                tap(heroes => this.log('done dadosLog')),
                timeout(20000),
                catchError(this.handleError('getVlr', []))
              );
          }
          getJsonUF (qUF: string): Observable<any[]> {
            return this.http.get<any[]>('/assets/dados/cidades/' + qUF + '.json' )
              .pipe(
                tap(heroes => this.log('done dadosLog')),
                timeout(20000),
                catchError(this.handleError('getVlr', []))
              );
          }
          getJsonExc (dadosLogin: string): Observable<any[]> {
            return this.http.get<any[]>('/assets/dados/exercicios.json')
              .pipe(
                tap(heroes => this.log('done dadosLog')),
                timeout(20000),
                catchError(this.handleError('getVlr', []))
              );
          }

          getUsuarios (dadosLogin: string): Observable<any[]> {
            return this.http.get<any[]>(this.pesquisarUsuarioUrl + dadosLogin)
              .pipe(
                tap(heroes => this.log('done dadosLog')),
                timeout(20000),
                catchError(this.handleError('getVlr', []))
              );
          }

          getLouP(dadosLogin: string): Observable<any[]> {
            return this.http.get<any[]>(this.pesquiasrlpUrl + dadosLogin)
              .pipe(
                tap(heroes => this.log('done dadosLog')),
                timeout(20000),
                catchError(this.handleError('getVlr', []))
              );
          }

          addFavLocal(dadosLogin: string): Observable<any[]> {
            return this.http.get<any[]>(this.addFavUrl + dadosLogin)
              .pipe(
                tap(heroes => this.log('done dadosLog')),
                timeout(20000),
                catchError(this.handleError('getVlr', []))
              );
          }
          removeFavLocal(dadosLogin: string): Observable<any[]> {
            return this.http.get<any[]>(this.removeFavUrl + dadosLogin)
              .pipe(
                tap(heroes => this.log('done dadosLog')),
                timeout(20000),
                catchError(this.handleError('getVlr', []))
              );
          }
         
          infoPouLEsp(dadosLogin: string): Observable<any[]> {
            return this.http.get<any[]>(this.infoEspecificaUrl + dadosLogin)
              .pipe(
                tap(heroes => this.log('done dadosLog')),
                timeout(20000),
                catchError(this.handleError('getVlr', []))
              );
          }
          
          listaBaseModalidades() :Observable<any[]> {
            return this.http.get<any[]>(this.listarBModalidadesUrl)
              .pipe(
                tap(heroes => this.log('done dadosLog')),
                timeout(20000),
                catchError(this.handleError('getVlr', []))
              );
          }

          salvarModal (dadosUser: any): Observable<any[]> {
            return this.http.post<any[]>(this.salvarModalidadesUrl, JSON.stringify(dadosUser), httpOptions)
              .pipe(
                tap(heroes => this.log('done dadosLog')),
                catchError(this.handleError('getVlr', []))
              );
          }

          removeModalidade(dadosLogin: string): Observable<any[]> {
            return this.http.get<any[]>(this.removeModalidadeUrl + dadosLogin)
              .pipe(
                tap(heroes => this.log('done dadosLog')),
                timeout(20000),
                catchError(this.handleError('getVlr', []))
              );
          }

          salvarConquista (dadosUser: any): Observable<any[]> {
            return this.http.post<any[]>(this.salvarConqUrl, JSON.stringify(dadosUser), httpOptions)
              .pipe(
                tap(heroes => this.log('done dadosLog')),
                catchError(this.handleError('getVlr', []))
              );
          }
          removerConquista(dadosLogin: string): Observable<any[]> {
            return this.http.get<any[]>(this.removeConqUrl + dadosLogin)
              .pipe(
                tap(heroes => this.log('done dadosLog')),
                timeout(20000),
                catchError(this.handleError('getVlr', []))
              );
          }
          infoConquista(dadosLogin: string): Observable<any[]> {
            return this.http.get<any[]>(this.infoConqUrl + dadosLogin)
              .pipe(
                tap(heroes => this.log('done dadosLog')),
                timeout(20000),
                catchError(this.handleError('getVlr', []))
              );
          }

          infoTitulo(dadosLogin: string): Observable<any[]> {
            return this.http.get<any[]>(this.infoTituloUrl + dadosLogin)
              .pipe(
                tap(heroes => this.log('done dadosLog')),
                timeout(20000),
                catchError(this.handleError('getVlr', []))
              );
          }
          salvarTitulo (dadosUser: any): Observable<any[]> {
            return this.http.post<any[]>(this.salvarTituloUrl, JSON.stringify(dadosUser), httpOptions)
              .pipe(
                tap(heroes => this.log('done dadosLog')),
                catchError(this.handleError('getVlr', []))
              );
          }
          removerTitulo(dadosLogin: string): Observable<any[]> {
            return this.http.get<any[]>(this.removeTituloUrl + dadosLogin)
              .pipe(
                tap(heroes => this.log('done dadosLog')),
                timeout(20000),
                catchError(this.handleError('getVlr', []))
              );
          }
          listaBaseCompeticoes() :Observable<any[]> {
            return this.http.get<any[]>(this.listarBaseCompeticoesUrl)
              .pipe(
                tap(heroes => this.log('done dadosLog')),
                timeout(20000),
                catchError(this.handleError('getVlr', []))
              );
          }

          listarUserCfg(dadosLogin: string): Observable<any[]> {
            return this.http.get<any[]>(this.listarCfgUrl + dadosLogin)
              .pipe(
                tap(heroes => this.log('done dadosLog')),
                timeout(20000),
                catchError(this.handleError('getVlr', []))
              );
          }

          eDitarPref(dadosLogin: string): Observable<any[]> {
            return this.http.get<any[]>(this.atualizarCfgUrl + dadosLogin)
              .pipe(
                tap(heroes => this.log('done dadosLog')),
                timeout(20000),
                catchError(this.handleError('getVlr', []))
              );
          }

          editarTipoPerifl(dadosUser: any) :Observable<any[]> {
            return this.http.post<any[]>(this.editarTipoPerfilUrl, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', [])),
              timeout(this.meutimeout)
            );
          }
          

          listarShopUF() :Observable<any[]> {
            return this.http.get<any[]>(this.listarUFshopUrl)
              .pipe(
                tap(heroes => this.log('done dadosLog')),
                timeout(20000),
                catchError(this.handleError('getVlr', []))
              );
          }
          listarShopCidades(dadosBusca: string) :Observable<any[]> {
            return this.http.get<any[]>(this.listarCidadesshopUrl + dadosBusca)
              .pipe(
                tap(heroes => this.log('done dadosLog')),
                timeout(20000),
                catchError(this.handleError('getVlr', []))
              );
          }
          listarShopCats() :Observable<any[]> {
            return this.http.get<any[]>(this.listarShopCatsUrl)
              .pipe(
                tap(heroes => this.log('done dadosLog')),
                timeout(20000),
                catchError(this.handleError('getVlr', []))
              );
          }
          listarShopDH(dadosBusca: string) :Observable<any[]> {
            return this.http.get<any[]>(this.listarShopDHUrl + dadosBusca)
              .pipe(
                tap(heroes => this.log('done dadosLog')),
                timeout(20000),
                catchError(this.handleError('getVlr', []))
              );
          }

          infoShopProd(dadosBusca: string) :Observable<any[]> {
            return this.http.get<any[]>(this.infoProdUrl + dadosBusca)
              .pipe(
                tap(heroes => this.log('done dadosLog')),
                timeout(20000),
                catchError(this.handleError('getVlr', []))
              );
          }
          listaProdCS(dadosBusca: string) :Observable<any[]> {
            return this.http.get<any[]>(this.listarProdByCSUrl + dadosBusca)
              .pipe(
                tap(heroes => this.log('done dadosLog')),
                timeout(20000),
                catchError(this.handleError('getVlr', []))
              );
          }


          buscarCEPVia(dadosBusca: string) :Observable<any[]> {
            return this.http.get<any[]>(this.wsViaCEP + dadosBusca)
              .pipe(
                tap(heroes => this.log('done dadosLog')),
                timeout(20000),
                catchError(this.handleError('getVlr', []))
              );
          }

          addNovoEndereco(dadosUser: any) :Observable<any[]> {
            return this.http.post<any[]>(this.novoEnderecoUrl, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', [])),
              timeout(this.meutimeout)
            );
          }
          listarEnderecos(dadosBusca: string) :Observable<any[]> {
            return this.http.get<any[]>(this.listarEnderecosUrl + dadosBusca)
              .pipe(
                tap(heroes => this.log('done dadosLog')),
                timeout(20000),
                catchError(this.handleError('getVlr', []))
              );
          }
          
          removerEndereco(dadosBusca: string) :Observable<any[]> {
            return this.http.get<any[]>(this.excluirEnderecoUrl + dadosBusca)
              .pipe(
                tap(heroes => this.log('done dadosLog')),
                timeout(20000),
                catchError(this.handleError('getVlr', []))
              );
          }

          listarPedidos(dadosBusca: string) :Observable<any[]> {
            return this.http.get<any[]>(this.listarPedidosUrl + dadosBusca)
              .pipe(
                tap(heroes => this.log('done dadosLog')),
                timeout(20000),
                catchError(this.handleError('getVlr', []))
              );
          }
          
          infoPedido(dadosBusca: string) :Observable<any[]> {
            return this.http.get<any[]>(this.infoPedidoUrl + dadosBusca)
              .pipe(
                tap(heroes => this.log('done dadosLog')),
                timeout(20000),
                catchError(this.handleError('getVlr', []))
              );
          }

          avaliarPedido(dadosUser: any) :Observable<any[]> {
            return this.http.post<any[]>(this.avaliarPedidoUrl, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', [])),
              timeout(this.meutimeout)
            );
          }

          criarSPS() :Observable<any[]> {
            return this.http.get<any[]>(this.criarSPSUrl)
              .pipe(
                tap(heroes => this.log('done dadosLog')),
                timeout(20000),
                catchError(this.handleError('getVlr', []))
              );
          }

          addNovoPedido(dadosUser: any) :Observable<any[]> {
            return this.http.post<any[]>(this.addNovoPedidoUrl, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', [])),
              timeout(this.meutimeout)
            );
          }
          
          addNovoPedidoNM(dadosUser: any) :Observable<any[]> {
            return this.http.post<any[]>(this.addNovoPedidoNewUrl, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', [])),
              timeout(this.meutimeout)
            );
          }
          
          checkProdQty(dadosUser: any) :Observable<any[]> {
            return this.http.post<any[]>(this.checkQtyUrl, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', [])),
              timeout(this.meutimeout)
            );
          }
          //salvar carrinho
          salvarICart(dadosUser: any) :Observable<any[]> {
            return this.http.post<any[]>(this.saveTempCartUrl, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', [])),
              timeout(this.meutimeout)
            );
          }

          zerarICart(dadosUser: any) :Observable<any[]> {
            return this.http.post<any[]>(this.zerarTempCartUrl, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', [])),
              timeout(this.meutimeout)
            );
          }
          //receitas
          listarReceitas(dadosUser: any) :Observable<any[]> {
            return this.http.post<any[]>(this.lReceitastUrl, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', [])),
              timeout(this.meutimeout)
            );
          }
          infoReceita(dadosUser: any) :Observable<any[]> {
            return this.http.post<any[]>(this.iReceitaUrl, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', [])),
              timeout(this.meutimeout)
            );
          }

          //chat
          listarChats(dadosUser: any) :Observable<any[]> {
            return this.http.post<any[]>(this.listarChatsUrl, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', [])),
              timeout(this.meutimeout)
            );
          }
          listarMsgs(dadosUser: any) :Observable<any[]> {
            return this.http.post<any[]>(this.carregarMsgChatUrl, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', [])),
              timeout(this.meutimeout)
            );
          }
          listarMsgsOld(dadosUser: any) :Observable<any[]> {
            return this.http.post<any[]>(this.carregarMsgOldChatUrl, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', [])),
              timeout(this.meutimeout)
            );
          }
          brokerMsg(dadosUser: any) :Observable<any[]> {
            return this.http.post<any[]>(this.chatBrokerUrl, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', [])),
              timeout(this.meutimeout)
            );
          }
          brokerListChat(dadosUser: any) :Observable<any[]> {
            return this.http.post<any[]>(this.chatListBrokerUrl, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', [])),
              timeout(this.meutimeout)
            );
          }
          brokerAllChat(dadosUser: any) :Observable<any[]> {
            return this.http.post<any[]>(this.chatAllBroker, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', [])),
              timeout(this.meutimeout)
            );
          }
          addNewMessageChat(dadosUser: any) :Observable<any[]> {
            return this.http.post<any[]>(this.chatAddMsgUrl, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', [])),
              timeout(this.meutimeout)
            );
          }

          blockUserChat(dadosUser: any) :Observable<any[]> {
            return this.http.post<any[]>(this.blockUserUrl, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', [])),
              timeout(this.meutimeout)
            );
          }

          unblockUserChat(dadosUser: any) :Observable<any[]> {
            return this.http.post<any[]>(this.unblockUserUrl, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', [])),
              timeout(this.meutimeout)
            );
          }

          

          //seguir
          followUser(dadosUser: any) :Observable<any[]> {
            return this.http.post<any[]>(this.followUserUrl, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', [])),
              timeout(this.meutimeout)
            );
          }
          unfollowUser(dadosUser: any) :Observable<any[]> {
            return this.http.post<any[]>(this.unfollowUserUrl, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', [])),
              timeout(this.meutimeout)
            );
          }

          listarMeusContatos(dadosUser: any) :Observable<any[]> {
            return this.http.post<any[]>(this.contatosListarUrl, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', [])),
              timeout(this.meutimeout)
            );
          }
          
          
          listarNetWork(dadosUser: any) :Observable<any[]> {
            return this.http.post<any[]>(this.carregarNetworkUrl, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', [])),
              timeout(this.meutimeout)
            );
            
          }
          listarFeed(dadosUser: any) :Observable<any[]> {
            return this.http.post<any[]>(this.socialCarregarFeedUrl, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', [])),
              timeout(this.meutimeout)
            );
          }
          
          listarFeedSimp(dadosUser: any) :Observable<any[]> {
            return this.http.post<any[]>(this.socialFeedLoadSimpUrl, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', [])),
              timeout(this.meutimeout)
            );
          }

          infoPost(dadosUser: any) :Observable<any[]> {
            return this.http.post<any[]>(this.socialCarregarPostUrl, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', [])),
              timeout(this.meutimeout)
            );
          }

          listarComentarios(dadosUser: any) :Observable<any[]> {
            return this.http.post<any[]>(this.socialCarregarCommentUrl, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', [])),
              timeout(this.meutimeout)
            );
          }
          listarReacoes(dadosUser: any) :Observable<any[]> {
            return this.http.post<any[]>(this.socialCarregarReactUrl, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', [])),
              timeout(this.meutimeout)
            );
          }


          addNovoPost(dadosUser: any) :Observable<any[]> {
            return this.http.post<any[]>(this.socialInserirPostUrl, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', [])),
              timeout(this.meutimeout)
            );
          }

          addComentario(dadosUser: any) :Observable<any[]> {
            return this.http.post<any[]>(this.socialInserirCommentUrl, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', [])),
              timeout(this.meutimeout)
            );
          }

          addReacao(dadosUser: any) :Observable<any[]> {
            return this.http.post<any[]>(this.socialInserirReactUrl, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', [])),
              timeout(this.meutimeout)
            );
          }

          remReacao(dadosUser: any) :Observable<any[]> {
            return this.http.post<any[]>(this.socialRemoverReactUrl, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', [])),
              timeout(this.meutimeout)
            );
          }


          excluirPost(dadosUser: any) :Observable<any[]> {
            return this.http.post<any[]>(this.exlcuirPostUrl, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', [])),
              timeout(this.meutimeout)
            );
          }

          reportPost(dadosUser: any) :Observable<any[]> {
            return this.http.post<any[]>(this.socialReportarPostUrl, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', [])),
              timeout(this.meutimeout)
            );
          }
          
          autorizarTorcedor(dadosUser: any) :Observable<any[]> {
            return this.http.post<any[]>(this.autorizarTorcedorUrl, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', [])),
              timeout(this.meutimeout)
            );
          }
          
          ativarTodasND(dadosUser: any) :Observable<any[]> {
            return this.http.post<any[]>(this.ativarNDUrl, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', [])),
              timeout(this.meutimeout)
            );
          }

          //premium
          listarPlanosPremium() :Observable<any[]> {
            return this.http.get<any[]>(this.planosPremiumUrl )
              .pipe(
                tap(heroes => this.log('done dadosLog')),
                timeout(20000),
                catchError(this.handleError('getVlr', []))
              );
          }

          listarPlanosPremiumPS() :Observable<any[]> {
            return this.http.get<any[]>(this.planosPremiumPSUrl )
              .pipe(
                tap(heroes => this.log('done dadosLog')),
                timeout(20000),
                catchError(this.handleError('getVlr', []))
              );
          }
           


          checkCupomPlanos(dadosUser: any) :Observable<any[]> {
            return this.http.post<any[]>(this.checkCupomPremiumUrl, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', [])),
              timeout(this.meutimeout)
            );
          }
          checkoutPlanoPremium(dadosUser: any) :Observable<any[]> {
            return this.http.post<any[]>(this.assinarPlanoPremiumUrl, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', [])),
              timeout(this.meutimeout)
            );
          }
          checkoutPlanoPremiumPS(dadosUser: any) :Observable<any[]> {
            return this.http.post<any[]>(this.assinarPlanoPremiumPSUrl, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', [])),
              timeout(60000)
            );
          }
          
          infoMeuPremium(dadosUser: any) :Observable<any[]> {
            return this.http.post<any[]>(this.statusPremiumUrl, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', [])),
              timeout(this.meutimeout)
            );
          }

          //dashboard
          getPacientes (dadosLogin: string): Observable<any[]> {
            return this.http.get<any[]>(this.listarPacientesUrl + dadosLogin)
              .pipe(
                tap(heroes => this.log('done dadosLog')),
                timeout(20000),
                catchError(this.handleError('error', []))
              );
          }
          getUltimosP (dadosLogin: string): Observable<any[]> {
            return this.http.get<any[]>(this.listarUltimosPacientesUrl + dadosLogin)
              .pipe(
                tap(heroes => this.log('done dadosLog')),
                timeout(20000),
                catchError(this.handleError('getVlr', []))
              );
          }
          getUltimasPre (dadosLogin: string): Observable<any[]> {
            return this.http.get<any[]>(this.listarUltimasPrecricoesUrl + dadosLogin)
              .pipe(
                tap(heroes => this.log('done dadosLog')),
                timeout(20000),
                catchError(this.handleError('getVlr', []))
              );
          }
          getUltimasAval (dadosLogin: string): Observable<any[]> {
            return this.http.get<any[]>(this.listarUltimasAvaliacoesUrl + dadosLogin)
              .pipe(
                tap(heroes => this.log('done dadosLog')),
                timeout(20000),
                catchError(this.handleError('getVlr', []))
              );
          }
          
          getUsuariosP (dadosLogin: string): Observable<any[]> {
            return this.http.get<any[]>(this.listarUsuariosP + dadosLogin)
              .pipe(
                tap(heroes => this.log('done dadosLog')),
                timeout(20000),
                catchError(this.handleError('getVlr', []))
              );
          }
          getInfoPaciente (dadosLogin: string): Observable<any[]> {
            return this.http.get<any[]>(this.listarInfoPacienteUrl + dadosLogin)
              .pipe(
                tap(heroes => this.log('done dadosLog')),
                timeout(20000),
                catchError(this.handleError('getVlr', []))
              );
          }

          getAderenciaAli(dadosBusca: string) :Observable<any[]> {
            return this.http.get<any[]>(this.buscarAderenciaAliUrl + dadosBusca)
              .pipe(
                tap(heroes => this.log('done dadosLog')),
                timeout(20000),
                catchError(this.handleError('getVlr', []))
              );
          }
          
          getAderenciaTre(dadosBusca: string) :Observable<any[]> {
            return this.http.get<any[]>(this.buscarAderenciaTreUrl + dadosBusca)
              .pipe(
                tap(heroes => this.log('done dadosLog')),
                timeout(20000),
                catchError(this.handleError('getVlr', []))
              );
          }
          
          getAvaliacoes(dadosBusca: string) :Observable<any[]> {
            return this.http.get<any[]>(this.listarAvalUrl + dadosBusca)
              .pipe(
                tap(heroes => this.log('done dadosLog')),
                timeout(20000),
                catchError(this.handleError('getVlr', []))
              );
          }
          
          getInfoAvaliacao(dadosBusca: string) :Observable<any[]> {
            return this.http.get<any[]>(this.infoAvaliacaoUrl + dadosBusca)
              .pipe(
                tap(heroes => this.log('done dadosLog')),
                timeout(20000),
                catchError(this.handleError('getVlr', []))
              );
          }

          excluirAvaliacao(dadosUser: any) :Observable<any[]> {
            return this.http.post<any[]>(this.excluirAvUrl, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', [])),
              timeout(this.meutimeout)
            );
          }

          compareAv(dadosUser: any) :Observable<any[]> {
            return this.http.post<any[]>(this.compararAvUrl, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', []))
            );
          }

          //nova avaliação
          criarAvaliacao(dadosUser: any) :Observable<any[]> {
            return this.http.post<any[]>(this.novaAvUrl, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', []))
            );
          }

          salvarAvaliacao(dadosUser: any) :Observable<any[]> {
            return this.http.post<any[]>(this.salvarAvUrl, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', []))
            );
          }

          salvarTesteCooper(dadosUser: any) :Observable<any[]> {
            return this.http.post<any[]>(this.salvarTCUrl, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', []))
            );
          }
          salvarTesteRM(dadosUser: any) :Observable<any[]> {
            return this.http.post<any[]>(this.salvarRMUrl, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', []))
            );
          }
          
          salvarDobras(dadosUser: any) :Observable<any[]> {
            return this.http.post<any[]>(this.salvarDobrasUrl, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', []))
            );
          }
          salvarTesteGET(dadosUser: any) :Observable<any[]> {
            return this.http.post<any[]>(this.salvarGETUrl, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', []))
            );
          }

          criarNovoPlanoAli(dadosUser: any) :Observable<any[]> {
            return this.http.post<any[]>(this.novoPlanoAliUrl, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', []))
            );
          }

          criarNovoPlanoExc(dadosUser: any) :Observable<any[]> {
            return this.http.post<any[]>(this.novoPlanoExcUrl, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', []))
            );
          }

          getInfoPlanoAli(dadosBusca: string) :Observable<any[]> {
            return this.http.get<any[]>(this.infoPlanoAliUrl + dadosBusca)
              .pipe(
                tap(heroes => this.log('done dadosLog')),
                timeout(20000),
                catchError(this.handleError('getVlr', []))
              );
          }

          getInfoPlanoExc(dadosBusca: string) :Observable<any[]> {
            return this.http.get<any[]>(this.infoPlanoExcUrl + dadosBusca)
              .pipe(
                tap(heroes => this.log('done dadosLog')),
                timeout(20000),
                catchError(this.handleError('getVlr', []))
              );
          }

          enviarPlanoAli(dadosUser: any) :Observable<any[]> {
            return this.http.post<any[]>(this.envPlanoAliUrl, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', []))
            );
          }

          enviarPlanoExc(dadosUser: any) :Observable<any[]> {
            return this.http.post<any[]>(this.envPlanoExcUrl, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', []))
            );
          }


          getInfoMrMs(dadosBusca: string) :Observable<any[]> {
            return this.http.get<any[]>(this.listarMrMsUrl + dadosBusca)
              .pipe(
                tap(heroes => this.log('done dadosLog')),
                timeout(20000),
                catchError(this.handleError('getVlr', []))
              );
          }

          criarRefeicao(dadosUser: any) :Observable<any[]> {
            return this.http.post<any[]>(this.addNovaRefUrl, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', []))
            );
          }
          
          editarRefeicao(dadosUser: any) :Observable<any[]> {
            return this.http.post<any[]>(this.atualizarRefUrl, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', []))
            );
          }

          excluirRefeicao(dadosUser: any) :Observable<any[]> {
            return this.http.post<any[]>(this.excluirRefUrl, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', []))
            );
          }


          salvarModeloAli(dadosUser: any) :Observable<any[]> {
            return this.http.post<any[]>(this.salvarModeloAliUrl, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', []))
            );
          }

          importarModeloAli(dadosUser: any) :Observable<any[]> {
            return this.http.post<any[]>(this.importarModeloAliUrl, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', []))
            );
          }


          getListaFichas(dadosBusca: string) :Observable<any[]> {
            return this.http.get<any[]>(this.listarFichasTUrl + dadosBusca)
              .pipe(
                tap(heroes => this.log('done dadosLog')),
                timeout(20000),
                catchError(this.handleError('getVlr', []))
              );
          }


          getListaExerciciosT(dadosBusca: string) :Observable<any[]> {
            return this.http.get<any[]>(this.listarExerciciosTUrl + dadosBusca)
              .pipe(
                tap(heroes => this.log('done dadosLog')),
                timeout(20000),
                catchError(this.handleError('getVlr', []))
              );
          }

          excluirExercicioT(dadosUser: any) :Observable<any[]> {
            return this.http.post<any[]>(this.excluirExercicioTUrl, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', []))
            );
          }

          excluirFichaTreino(dadosUser: any) :Observable<any[]> {
            return this.http.post<any[]>(this.excluirFichaTUrl, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', []))
            );
          }

          excluirPlanoT(dadosUser: any) :Observable<any[]> {
            return this.http.post<any[]>(this.excluirPlanoTUrl, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', []))
            );
          }
          excluirPlanoA(dadosUser: any) :Observable<any[]> {
            return this.http.post<any[]>(this.excluirPlanoAUrl, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', []))
            );
          }
          
          excluirMacroT(dadosUser: any) :Observable<any[]> {
            return this.http.post<any[]>(this.excluirMacroTUrl, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', []))
            );
          }


          addNovaFichaT(dadosUser: any) :Observable<any[]> {
            return this.http.post<any[]>(this.novaFichaExcUrl, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', []))
            );
          }

          addNovoExcT(dadosUser: any) :Observable<any[]> {
            return this.http.post<any[]>(this.novoExcTUrl, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', []))
            );
          }

          atualizarExcT(dadosUser: any) :Observable<any[]> {
            return this.http.post<any[]>(this.attExcTUrl, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', []))
            );
          }


          criarRelPA(dadosUser: any) :Observable<any[]> {
            return this.http.post<any[]>(this.novaRelacaoPAUrl, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', []))
            );
          }

          novoPreCadastro(dadosUser: any) :Observable<any[]> {
            return this.http.post<any[]>(this.novoPreCadastroUrl, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', []))
            );
          }


          novoContatoNegocio(dadosUser: any) :Observable<any[]> {
            return this.http.post<any[]>(this.envCTNegocioUrl, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', []))
            );
          }

          novoContatoSimples(dadosUser: any) :Observable<any[]> {
            return this.http.post<any[]>(this.envCTSimplesUrl, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', []))
            );
          }

          
          getQtyNotificacoes(dadosLogin: any): Observable<any[]> {
            return this.http.post<any[]>(this.qtyNotificacoesUrl, JSON.stringify(dadosLogin), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', []))
            );
          }

          listarNotificacoes (dadosLogin: string): Observable<any[]> {
            return this.http.get<any[]>(this.listarNotificacoesUrl + dadosLogin)
              .pipe(
                tap(heroes => this.log('done dadosLog')),
                timeout(20000),
                catchError(this.handleError('getVlr', []))
              );
          }

          infoNotificacao (dadosLogin: string): Observable<any[]> {
            return this.http.get<any[]>(this.listarNotificacaoUrl + dadosLogin)
              .pipe(
                tap(heroes => this.log('done dadosLog')),
                timeout(20000),
                catchError(this.handleError('getVlr', []))
              );
          }
          
          notificacaoVisuali(dadosLogin: any): Observable<any[]> {
            return this.http.post<any[]>(this.notificacaoViUrl, JSON.stringify(dadosLogin), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', []))
            );
          }

          aceitePro(dadosLogin: any): Observable<any[]> {
            return this.http.post<any[]>(this.aceiteProUrl, JSON.stringify(dadosLogin), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', []))
            );
          }

          excluirConta(dadosUser: any) :Observable<any[]> {
            return this.http.post<any[]>(this.excluirContaUrl, JSON.stringify(dadosUser), httpOptions)
            .pipe(
              tap(heroes => this.log('done dadosLog')),
              catchError(this.handleError('getVlr', []))
            );
          }

          forceLogout() : boolean{
            this.hcEmail = '';
            this.hcSenha = '';
            this.hcNomeUsuario = ''
            this.logado = false;
            localStorage.removeItem('tmsDadosCliente');
            infoDeslogado();
            return true;

          }

          notificationAllowed(opcaoNotify: boolean){
            this.notificationChange.next(this.notificacaoAtiva = opcaoNotify);
          }


    /**
     * Handle Http operation that failed.
     * Let the app continue.
     * @param operation - name of the operation that failed
     * @param result - optional value to return as the observable result
     */
  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  /** Log a HeroService message with the MessageService */
  private log(message: string) {
    this.messageService.add(`HeroService: ${message}`);
  }
}